import React from 'react';
import { IconButton } from '@material-ui/core';
import Tooltip, { InfoPropTypes } from 'components/Tooltip';
import Proptypes from 'prop-types';
import { ConditionalWrapper } from 'utils/render';
import cn from 'classnames';
import styles from './index.module.scss';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    fill: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
  },
  rootDark: {
    fill: `${theme.palette.text.primary} !important`,
    color: `${theme.palette.text.primary} !important`,
  },
  mySvgStyleMedium: {
    height: '30px', //*[@id="Layer_1"]/g/path
    width: '30px',
    fill: `${theme.palette.text.primary} !important`,
    cursor: 'pointer',
    '& [id="Layer_1"]': {
      color: `${theme.palette.text.primary} !important`,
      '& [class*="st0"]': {
        fill: `${theme.palette.text.primary} !important`,
      },
    },
  },
  mySvgStyleMediumLight: {
    height: '30px', //*[@id="Layer_1"]/g/path
    width: '30px',
    fill: `${theme.palette.secondary.light} !important`,
    cursor: 'pointer',
    '& [id="Layer_1"]': {
      color: `${theme.palette.secondary.light} !important`,
      '& [class*="st0"]': {
        fill: `${theme.palette.secondary.light} !important`,
      },
    },
  },
}));
const ButtonIcon = ({
  component: Component,
  onClick,
  iconProps,
  className,
  text,
  noHorizontalPadding,
  size = 's',
  theme,
  ...props
}) => {
  const classes = useStyles();
  const withTooltip = children => (
    <Tooltip displayIcon={false} text={text}>
      {children}
    </Tooltip>
  );

  return (
    <ConditionalWrapper condition={text} wrapper={withTooltip}>
      <IconButton
        disableRipple
        size="small"
        className={cn(
          { [styles.noHorizontalPadding]: noHorizontalPadding },
          className,
        )}
        onClick={onClick}
        classes={{
          root: theme === 'dark' ? classes.rootDark : classes.root,
        }}
        {...props}
      >
        <Component
          {...iconProps}
          className={cn({
            [classes.mySvgStyleMedium]: size === 'm',
            [classes.mySvgStyleMediumLight]: theme === 'light',
          })}
        />
      </IconButton>
    </ConditionalWrapper>
  );
};

ButtonIcon.propTypes = {
  component: Proptypes.oneOfType([
    Proptypes.func,
    Proptypes.node,
    Proptypes.object, // type of react.memo gives an object type
  ]),
  onClick: Proptypes.func,
  iconProps: Proptypes.object,
  className: Proptypes.string,
  size: Proptypes.oneOf(['s', 'm']),
  theme: Proptypes.oneOf(['dark', 'light']),
  text: InfoPropTypes,
  noHorizontalPadding: Proptypes.bool,
};

export default ButtonIcon;
